/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Body_Assessment_Delete_BodyInputs */

const en_us2_body_assessment_delete_body = /** @type {(inputs: Body_Assessment_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Both photos and the numbers leave your history. This cannot be undone.`)
};

const pt_br2_body_assessment_delete_body = /** @type {(inputs: Body_Assessment_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As duas fotos e os números saem do seu histórico. Não dá para desfazer.`)
};

const es_419_body_assessment_delete_body = /** @type {(inputs: Body_Assessment_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Las dos fotos y los números salen de tu historial. No se puede deshacer.`)
};

const pt_pt2_body_assessment_delete_body = /** @type {(inputs: Body_Assessment_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`As duas fotos e os números saem do teu histórico. Não é possível anular.`)
};

const fr_fr2_body_assessment_delete_body = /** @type {(inputs: Body_Assessment_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Les deux photos et les chiffres quittent ton historique. C'est irréversible.`)
};

const de_de2_body_assessment_delete_body = /** @type {(inputs: Body_Assessment_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Beide Fotos und die Zahlen verschwinden aus deinem Verlauf. Das lässt sich nicht rückgängig machen.`)
};

const it_it2_body_assessment_delete_body = /** @type {(inputs: Body_Assessment_Delete_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Entrambe le foto e i numeri escono dal tuo storico. Non si può annullare.`)
};

/**
* | output |
* | --- |
* | "Both photos and the numbers leave your history. This cannot be undone." |
*
* @param {Body_Assessment_Delete_BodyInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const body_assessment_delete_body = /** @type {((inputs?: Body_Assessment_Delete_BodyInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Body_Assessment_Delete_BodyInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_body_assessment_delete_body(inputs)
	if (locale === "es-419") return es_419_body_assessment_delete_body(inputs)
	if (locale === "pt-PT") return pt_pt2_body_assessment_delete_body(inputs)
	if (locale === "fr-FR") return fr_fr2_body_assessment_delete_body(inputs)
	if (locale === "de-DE") return de_de2_body_assessment_delete_body(inputs)
	if (locale === "it-IT") return it_it2_body_assessment_delete_body(inputs)
	return en_us2_body_assessment_delete_body(inputs)
});
export { body_assessment_delete_body as "body-assessment.delete_body" }